module.exports = __webpack_public_path__ + "img/pin.f59efa05.svg";